<template>
  <v-container fluid>
    <div class="d-flex justify-space-between align-center py-2">
      <span class="ml-1 title font-weight-medium flex-shrink-0">
        สิทธิ์การลาพนักงาน
        <v-menu offset-y :close-on-content-click="false">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="align-self-end ml-2 mb-1"
              outlined
              v-bind="attrs"
              v-on="on"
              small
              color="grey darken-3"
            >
              <v-icon left>mdi-format-list-checkbox</v-icon>
              คอลัมน์
            </v-btn>
          </template>
          <ul class="white pl-4 pr-6 pt-2 pb-4" style="list-style: none">
            <li
              v-for="item in headerCustomTableViewMenu"
              :key="item.leave_type_code"
            >
              <v-checkbox
                v-model="item.checked"
                dense
                hide-details
                :disabled="item.disabled"
                @change="handleCustomCheckViewMenu(item)"
              >
                <template v-slot:label>
                  <span style="font-size: 14px">{{ item.text }}</span>
                </template>
              </v-checkbox>
            </li>
          </ul>
        </v-menu>
      </span>
    </div>
    <div class="my-2 d-flex justify-space-between align-end flex-wrap">
      <div class="d-flex">
        <div class="mr-2">
          <v-text-field
            v-model="search"
            class="px-0"
            label="รหัส - ชื่อพนักงาน"
            prepend-inner-icon="mdi-magnify"
            clearable
            flat
            solo
            dense
            hide-details
            @input="handleSearch"
            style="width: 240px; padding: 1px 5px"
          ></v-text-field>
        </div>
        <v-autocomplete
          v-model="filterOrganization"
          :items="organizations"
          item-text="text"
          item-value="organization_uuid"
          label="หน่วยงาน"
          prepend-inner-icon="mdi-filter-variant"
          clearable
          dense
          outlined
          hide-details
          @change="handleFilterOrganization"
          style="max-width: 240px"
        ></v-autocomplete>
      </div>
      <div class="d-flex align-end flex-wrap">
        <div>
          <label class="caption">ประเภทพนักงาน</label>
          <v-select
            v-model="employmentTypeId"
            :items="[
              { text: 'พนักงานรายเดือน', value: 0 },
              { text: 'พนักงานรายวัน', value: 1 },
            ]"
            item-text="text"
            item-value="value"
            outlined
            dense
            hide-details
            style="width: 180px"
            @change="handleChangeEmploymentTypeId"
          ></v-select>
        </div>
        <div class="ml-2">
          <label class="caption">เริ่มวันที่</label>
          <v-card
            outlined
            style="
              padding: 9.5px 60px 9.5px 10px;
              font-size: 14px;
              cursor: not-allowed;
            "
            >{{ leavePeriodStartDate | formatDate }}</v-card
          >
        </div>
        <div class="ml-2">
          <label class="caption">ปีสิทธิ (ค.ศ.)</label>
          <div class="start-date-picker">
            <date-picker
              v-model="yearPeriod"
              type="year"
              :clearable="false"
            ></date-picker>
          </div>
        </div>
      </div>
    </div>
    <v-data-table
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      :loading="loading"
      :headers="headers"
      :items="employeeLeaveRights"
      :options.sync="optionsEmployeeLeaveRight"
      :server-items-length="totalEmployeeLeaveRights"
      :items-per-page="10"
      class="elevation-1"
      :footer-props="{
        itemsPerPageOptions: [10, 25, 50, 100],
        itemsPerPageText: 'Rows per page:',
      }"
    >
      <template v-slot:item="{ item }">
        <tr @click="handleRowSelected(item)" :class="classRowSelected(item)">
          <!-- Employee -->
          <td>{{ item.employee_code }}</td>
          <td>{{ item.firstname_th }} {{ item.lastname_th }}</td>
          <td v-if="isOrganizationVisible">
            {{ item.organization.title_th }}
          </td>

          <!-- Leave Rights -->
          <td v-for="header in leaveRightHeaders" :key="header.text">
            {{ getLeaveRightText(item, header) }}
          </td>
        </tr>
      </template>
    </v-data-table>
    <EmployeeLeaveRightForm
      :formShow="employeeLeaveRightFormShow"
      :formAction="employeeLeaveRightFormAction"
      :employeeLeaveRight="employeeLeaveRight"
      :employeeLeaveRightInit="employeeLeaveRightInit"
      @isEmployeeLeaveRightDataChange="handleEmployeeLeaveRightFormDataChange"
      @formActionCompleted="handleEmployeeLeaveRightFormActionCompleted"
      @onReset="handleEmployeeLeaveRightFormReset"
    />
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
    <ForbiddenDialog
      :dialog="dialogForbidden"
      @onCloseDialog="dialogForbidden = false"
    />
  </v-container>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import { mapActions } from 'vuex'

// @ is an alias to /src
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import EmployeeLeaveRightForm from '@/views/employee-leave-right/EmployeeLeaveRightForm.vue'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'

export default {
  components: {
    ConfirmDialog,
    EmployeeLeaveRightForm,
    DatePicker,
  },
  data() {
    return {
      dialogForbidden: false,
      employmentTypeId: 0,
      leavePeriodStartDate: new Date(),
      yearPeriod: new Date(),
      sortBy: ['employee_code'],
      sortDesc: [false],
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
      loading: true,
      search: '',
      filterOrganization: null,
      headers: [
        {
          text: 'รหัสพนักงาน',
          align: 'start',
          value: 'employee_code',
          class: 'text-no-wrap',
          width: 140,
        },
        {
          text: 'ชื่อ-นามสกุล',
          align: 'start',
          value: 'full_name',
          class: 'text-no-wrap',
          width: 180,
        },
        {
          text: 'หน่วยงาน',
          align: 'start',
          value: 'organization',
          class: 'text-no-wrap',
          width: 180,
        },
      ],
      headerCustomTableViewMenu: [
        {
          text: 'รหัสพนักงาน',
          value: 'employee_code',
          checked: true,
          disabled: true,
        },
        {
          text: 'ชื่อ-นามสกุล',
          value: 'full_name',
          checked: true,
          disabled: true,
        },
        {
          text: 'หน่วยงาน',
          align: 'start',
          value: 'organization',
          class: 'text-no-wrap',
          width: 180,
          checked: true,
          disabled: false,
          leave_type_code: 'organization',
        },
      ],
      employeeLeaveRightFormShow: false,
      employeeLeaveRightFormAction: '',
      employeeLeaveRight: {
        leave_rights: [],
      },
      employeeLeaveRightInit: {
        leave_rights: [],
      },
      isEmployeeLeaveRightDataChange: false,
      cancelSource: null,
      timeout: null,
      optionsEmployeeLeaveRight: {},
      employeeLeaveRights: [],
      totalEmployeeLeaveRights: 0,
      isInit: true,
    }
  },
  filters: {
    formatDate: function (value) {
      return moment(value).format('DD/MM/YYYY')
    },
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    organizations() {
      return this.$store.state.organization.organizations.map((org) => ({
        organization_uuid: org.organization_uuid,
        text: `${org.organization_code} - ${org.title_th}`,
      }))
    },
    isOrganizationVisible() {
      return this.headers.some((h) => h.value === 'organization')
    },
    leaveRightHeaders() {
      const fixedValues = ['employee_code', 'full_name', 'organization']
      return this.headers
        .filter((h) => !fixedValues.includes(h.value))
        .map((h) => ({ ...h, sortable: false }))
    },
  },
  watch: {
    async yearPeriod() {
      this.optionsEmployeeLeaveRight.page = 1

      await this.getConfigLeavePeriodStartDate()
      await this.loadData()
    },
    optionsEmployeeLeaveRight: {
      async handler() {
        if (this.isInit) {
          this.isInit = false
          return
        }

        await this.getConfigLeavePeriodStartDate()
        await this.loadData()
      },
      deep: true,
    },
  },
  async created() {
    this.$store.commit('SET_BREADCRUMBS', [
      { text: 'หน้าหลัก', disabled: false, to: '/' },
      {
        text: 'สิทธิ์การลาพนักงาน',
        disabled: true,
      },
    ])

    const { company_uuid } = this.$store.state.authentication.company

    await this.fetchOrganizations({
      company_uuid,
      params: {
        dpc: 'employee-leave-rights-to-list-organization',
        sort: 'organization_code:asc',
        field: 'organization_uuid,organization_code,title_th,organization_boss',
      },
    })

    await this.getConfigLeavePeriodStartDate()
    await this.loadData()

    const leaveRightCustomMenuInit =
      this.employeeLeaveRights[0].leave_rights.map((leaveRight, index) => ({
        leave_type_code: leaveRight.leave_type_code,
        text: leaveRight.title_th,
        align: 'start',
        class: 'text-no-wrap',
        width: 120,
        checked: index < 3 ? true : false,
      }))

    this.headerCustomTableViewMenu = [
      ...this.headerCustomTableViewMenu,
      ...leaveRightCustomMenuInit,
    ]

    this.headers = [
      ...this.headers,
      ...leaveRightCustomMenuInit
        .filter((item) => item.checked)
        .map((item) => {
          return {
            text: item.text,
            align: 'start',
            class: 'text-no-wrap',
            value: item.leave_type_code,
            width: 120,
            sortable: false,
          }
        }),
    ]
  },
  methods: {
    ...mapActions({
      fetchEmployeeLeaveRights: 'employeeLeaveRight/fetchEmployeeLeaveRights',
      fetchConfigLeavePeriodStartDate: 'leave/fetchConfigLeavePeriodStartDate',
      fetchOrganizations: 'organization/fetchOrganizations',
    }),
    handleSearch() {
      this.getEmployeesBySearch()
    },
    getEmployeesBySearch: _.debounce(async function () {
      this.optionsEmployeeLeaveRight.page = 1

      // await this.getConfigLeavePeriodStartDate()
      await this.loadData()
    }, 500),
    async handleFilterOrganization() {
      this.optionsEmployeeLeaveRight.page = 1

      // await this.getConfigLeavePeriodStartDate()
      await this.loadData()
    },
    async handleChangeEmploymentTypeId() {
      this.optionsEmployeeLeaveRight.page = 1

      await this.getConfigLeavePeriodStartDate()
      await this.loadData()
    },
    async getConfigLeavePeriodStartDate() {
      try {
        const { company_uuid } = this.$store.state.authentication.company

        const payload = {
          company_uuid,
          params: {
            dpc: 'employee-leave-rights-to-get-system-config-leave-entitlements',
          },
        }

        await this.fetchConfigLeavePeriodStartDate(payload)
        const configLeavePeriodStartDate =
          this.$store.state.leave.configLeavePeriodStartDate
        if (configLeavePeriodStartDate) {
          const employmentType =
            this.employmentTypeId === 0 ? 'monthly' : 'daily'
          const config = configLeavePeriodStartDate[employmentType]

          if (config && config.day && config.month) {
            const year =
              this.yearPeriod instanceof Date
                ? this.yearPeriod.getFullYear()
                : parseInt(this.yearPeriod)
            const adjustedYear = config.month >= 10 ? year - 1 : year
            const startDate = new Date(
              adjustedYear,
              config.month - 1,
              config.day
            )
            if (!isNaN(startDate.getTime())) {
              this.leavePeriodStartDate = startDate
            }
          }
        }
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      }
    },
    classRowSelected(row) {
      if (this.employeeLeaveRight.employee_uuid === row.employee_uuid)
        return 'row-selected'
    },
    setDataRowSelected(row) {
      if (
        this.uiCtrl &&
        !this.uiCtrl.isEnable('row:::leave:leave_rights:employee:get')
      ) {
        this.dialogForbidden = true
        return
      }

      if (this.employeeLeaveRight.employee_uuid === row.employee_uuid) {
        this.employeeLeaveRightFormShow = false
        this.employeeLeaveRightFormAction = ''
        this.employeeLeaveRight = {
          leave_rights: [],
        }
        this.employeeLeaveRightInit = {
          leave_rights: [],
        }
      } else {
        this.employeeLeaveRightFormShow = true
        this.employeeLeaveRightFormAction = 'edit'
        this.employeeLeaveRight = {
          ...row,
          leave_rights: row.leave_rights.map((lr) => ({ ...lr })),
          year_period: this.yearPeriod
            ? this.yearPeriod instanceof Date
              ? this.yearPeriod.getFullYear()
              : parseInt(this.yearPeriod)
            : null,
        }
        this.employeeLeaveRightInit = {
          ...row,
          leave_rights: row.leave_rights.map((lr) => ({ ...lr })),
          year_period: this.yearPeriod
            ? this.yearPeriod instanceof Date
              ? this.yearPeriod.getFullYear()
              : parseInt(this.yearPeriod)
            : null,
        }
      }
    },
    handleRowSelected(row) {
      if (this.isEmployeeLeaveRightDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
          item: {
            type: 'row',
            data: row,
          },
        }
        this.confirmDialogDataChange = true
      } else {
        this.setDataRowSelected(row)
      }
    },
    handleEmployeeLeaveRightFormDataChange(value) {
      this.isEmployeeLeaveRightDataChange = value
    },
    handleEmployeeLeaveRightFormReset(formAction) {
      this.employeeLeaveRight = {
        leave_rights: [],
      }
      this.employeeLeaveRightInit = {
        leave_rights: [],
      }

      this.isEmployeeLeaveRightDataChange = false

      this.employeeLeaveRightFormShow = false
      this.employeeLeaveRightFormAction = ''
    },
    async handleEmployeeLeaveRightFormActionCompleted(formAction) {
      if (formAction === 'edit') {
        await this.loadData()
      }

      this.employeeLeaveRight = {
        leave_rights: [],
      }
      this.employeeLeaveRightInit = {
        leave_rights: [],
      }

      this.isEmployeeLeaveRightDataChange = false

      this.employeeLeaveRightFormShow = false
      this.employeeLeaveRightFormAction = ''
    },
    getLeaveRightText(item, header) {
      const leaveRight = item.leave_rights.find(
        (lr) => lr.leave_type_code === header.value
      )
      return `${leaveRight?.day_rights || '0'} วัน / ${
        leaveRight?.hour_rights || '0'
      } ชั่วโมง`
    },
    handleCustomCheckViewMenu(item) {
      if (item.checked === false) {
        this.headers = this.headers.filter(
          (header) => header.value !== item.leave_type_code
        )
      } else {
        const newHeader = {
          text: item.text,
          align: 'start',
          class: 'text-no-wrap',
          value: item.leave_type_code,
          width: 120,
          sortable: false,
        }

        // Insert at correct position based on headerCustomTableViewMenu order
        const menuIndex = this.headerCustomTableViewMenu.findIndex(
          (m) => m.leave_type_code === item.leave_type_code
        )
        let insertIndex = this.headers.length
        for (let i = menuIndex - 1; i >= 0; i--) {
          const prevItem = this.headerCustomTableViewMenu[i]
          const headerIndex = this.headers.findIndex(
            (h) =>
              h.value === prevItem.leave_type_code || h.value === prevItem.value
          )
          if (headerIndex !== -1) {
            insertIndex = headerIndex + 1
            break
          }
        }
        this.headers.splice(insertIndex, 0, newHeader)
      }
    },
    async loadData() {
      try {
        const { sortBy, sortDesc, page, itemsPerPage } =
          this.optionsEmployeeLeaveRight

        const sortKey = [...sortBy]

        if (sortKey[0] === 'full_name') {
          sortKey[0] = 'firstname_th'
        }
        if (sortKey[0] === 'organization') {
          sortKey[0] = 'organization_th'
        }

        const sortParams = sortKey
          .map((field, i) => `${field}:${sortDesc[i] ? 'desc' : 'asc'}`)
          .join(',')

        if (this.cancelSource) {
          this.cancelSource.abort()
        }

        const controller = new AbortController()
        this.cancelSource = controller

        const { company_uuid } = this.$store.state.authentication.company

        const payload = {
          company_uuid,
          params: {
            dpc: 'employee-leave-rights-to-list-employee-leave-rights',
            employment_type_id: this.employmentTypeId,
            leave_period_start_date: this.leavePeriodStartDate
              ? [
                  this.leavePeriodStartDate.getFullYear(),
                  String(this.leavePeriodStartDate.getMonth() + 1).padStart(
                    2,
                    '0'
                  ),
                  String(this.leavePeriodStartDate.getDate()).padStart(2, '0'),
                ].join('-')
              : null,
            year_period: this.yearPeriod
              ? this.yearPeriod instanceof Date
                ? this.yearPeriod.getFullYear()
                : parseInt(this.yearPeriod)
              : null,
            search: this.search || null,
            organization_uuid: this.filterOrganization || null,
            sort: sortParams || null,
            limit: itemsPerPage,
            offset: (page - 1) * itemsPerPage,
          },
          signal: controller.signal,
        }

        this.loading = true

        const { data, total } = await this.fetchEmployeeLeaveRights(payload)

        this.employeeLeaveRights = data
        this.totalEmployeeLeaveRights = total
      } catch (error) {
        if (error.name === 'CanceledError') {
          // Request was cancelled, do nothing
          return
        }

        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.loading = false
      }
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange(item) {
      if (item.type === 'row') {
        this.confirmDialogDataChange = false
        this.setDataRowSelected(item.data)
      } else {
        this.confirmDialogDataChange = false
        this.nextRoute(item.data)
      }
    },
    nextRoute(next) {
      this.employeeLeaveRightFormShow = false

      this.timeout = setTimeout(() => {
        next()
      }, 200)
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.isEmployeeLeaveRightDataChange) {
      this.confirmDialogDataChangeData = {
        title: 'ต้องการออกจากหน้านี้ใช่ไหม',
        text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการออกโดยที่ยังไม่บันทึกข้อมูล',
        value: '',
        item: {
          type: 'next',
          data: next,
        },
      }
      this.confirmDialogDataChange = true
    } else {
      this.nextRoute(next)
    }
  },
  beforeDestroy() {
    if (this.cancelSource) {
      this.cancelSource.abort()
    }

    clearTimeout(this.timeout)
  },
}
</script>

<style scoped>
::v-deep .start-date-picker input {
  font-weight: 600 !important;
  color: #333333 !important;
}
</style>
